import { $api } from "../generated/client";

export default function useGetImportTaskFileUrl(
  shopId: string,
  importId: string,
  taskId: string,
  enabled: boolean,
) {
  return $api.useQuery(
    "get",
    "/shops/{shopId}/imports/{importId}/tasks/{taskId}/file",
    {
      params: { path: { shopId, importId, taskId } },
    },
    { enabled, staleTime: 0 },
  );
}
